
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { SandboxConfigurationCard } from './components/sandbox-configuration-card'
import { SandboxBehaviorCard } from './components/sandbox-behavior-card'
import { SandboxTestingInfoCard } from './components/sandbox-testing-info-card'
import { SandboxFeaturesCard } from './components/sandbox-features-card'
import { SandboxDatabaseCard } from './components/sandbox-database-card'

interface SandboxDetailsPageProps {
    processor: ProcessorDetails
}

export const SandboxDetailsPage = ({ processor }: SandboxDetailsPageProps) => {
    return (
        <div className="container mx-auto py-8">
            <ProcessorHeader
                processor={processor}
                type="sandbox"
            />
            <ProcessorOverviewCard
                processor={processor}
                testModeWarningKey="sandboxTestModeWarning"
            />
            <ProcessorMetricsCard processor={processor} />
            <SandboxConfigurationCard processor={processor} />
            <SandboxBehaviorCard processor={processor} />
            <SandboxTestingInfoCard />
            <SandboxFeaturesCard />
            <SandboxDatabaseCard />

        </div>
    )
}

